import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useFavorites } from '../context/FavoritesContext';
import { useAuth } from '../context/AuthContext';
import './Header.css';

function Header() {
  const { getCartCount } = useCart();
  const { getFavoritesCount } = useFavorites();
  const { isShopper, isAdmin } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  React.useEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.classList.toggle('menu-open', mobileMenuOpen);
    }
  }, [mobileMenuOpen]);

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo">
            <img src="/logo.png" alt="Heritage Hub Logo" className="logo-image" />
          </Link>

          <div className="site-title" aria-hidden>
            <h1>Heritage Hub</h1>
          </div>
          
          {/* Hamburger Menu Button */}
          <button 
            className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          
          <ul className={`nav-links ${mobileMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
            <li><Link to="/products" onClick={closeMobileMenu}>Products</Link></li>
            <li><Link to="/cultures" onClick={closeMobileMenu}>Cultures</Link></li>
            <li><Link to="/vendor-application" onClick={closeMobileMenu}>Become a Vendor</Link></li>
            <li>
              <Link to="/favorites" className="favorites-link" onClick={closeMobileMenu}>
                ♡ Favorites ({getFavoritesCount()})
              </Link>
            </li>
            <li>
              <Link to="/cart" className="cart-link" onClick={closeMobileMenu}>
                🛒 Cart ({getCartCount()})
              </Link>
            </li>
            {!isShopper() && !isAdmin() ? (
              <li>
                <Link to="/login" className="login-link" onClick={closeMobileMenu}>Login / Register</Link>
              </li>
            ) : (
              <li>
                <Link
                  to={isAdmin() ? '/admin/dashboard' : '/shopper/account'}
                  className="login-link"
                  onClick={closeMobileMenu}
                >
                  {isAdmin() ? 'Admin Dashboard' : 'My Account'}
                </Link>
              </li>
            )}
          </ul>
          <div className="header-actions">
            <Link to="/favorites" className="icon-btn favorites-icon" aria-label="Favorites">
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
              <span className="count">{getFavoritesCount()}</span>
            </Link>
            <Link to="/cart" className="icon-btn cart-icon" aria-label="Cart">
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2S15.9 22 17 22s2-.9 2-2-.9-2-2-2zM7.16 14h9.34c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 21.84 5H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C3.52 15.37 4.48 17 6 17h12v-2H7.16z" />
              </svg>
              <span className="count">{getCartCount()}</span>
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
